import {
  Component,
  OnInit,
  Input,
  ViewChild,
  TemplateRef,
} from "@angular/core";
import { HttpClient } from "@angular/common/http";
import {
  FormBuilder,
  FormGroup,
  FormControl,
  AbstractControl,
  Validators,
} from "@angular/forms";
import { Observable } from "rxjs/Observable";
import { ToasterService } from "angular2-toaster";
import swal from "sweetalert2";
import * as _ from "lodash";
import { Store } from "@ngrx/store";
import * as fromCommonStore from "../../../store";
import * as fromRootStore from "../../../reducers";
import * as moment from "moment";
// import { VoucherDateChangeModel } from "../../../model/index";
import {
  CommonService,
} from "../../../services/index";
import { HamodelModel } from '../../../model/index';

@Component({
  selector: "datechange-tab",
  templateUrl: "./datechange.component.html",
})
export class VoucherDateChangeComponent implements OnInit {
  @Input("tabTitle") title: string;
  @Input() active = false;
  @Input() isCloseable = false;
  @Input("params") params: string;
  //@Input() dataContext;

  public mode: string;
  public list: any[] = [];
  public serviceList: any[] = [];
  partyCtrl: FormControl;
  typeCtrl: FormControl;
  numCtrl: FormControl;
  modelCtrl: FormControl;
  dateCtrl: FormControl;
  branchCtrl: FormControl;
  filteredBranch: Observable<any[]>;
  isLoadMask: Promise<any>;
  serviceDet: HamodelModel[];
  isLoading: boolean = false;
  filterData = {
    search_data: "",
  };
  loadingIndicator: boolean = true;
  //reorderable: boolean = true;
  filteredParty: Observable<any[]>;
  filteredModel: Observable<any[]>;
  PartyList = [];
  ModelList = [];
  typeList = [];
  paymentList = [];
  actModelList = [];
  branchList: any[] = [];
  page = {
    limit: 25,
    count: 0,
    offset: 0,
    orderBy: "Sno",
    orderDir: "asc",
  };

  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("editDeleteTemplate") editDeleteTemplate: TemplateRef<any>;
  @ViewChild("filterPanel") filterPanel;

  columns = [];
  scrollTimeout: any;
  suppressPaging: boolean = false;
  showBranch = true;
  subscribeBranch;
  showUpdate: boolean;
  constructor(
    public store: Store<fromRootStore.State>,
    //private VoucherDateChangeService: VoucherDateChangeService,
    public toasterService: ToasterService,
    private commonService: CommonService
  ) {
    //FOR AUTO COMPLETE VALIDATION --- PARTY COMBO
    // function hasValidParty(input: FormControl) {
    //   let partyID = input.value,
    //     retVal = null;
    //   if (partyID == "") {
    //     retVal = { inValidParty: true };
    //   }
    //   if (partyID && typeof partyID === "string") {
    //     retVal = { inValidParty: true };
    //   }
    //   return retVal;
    // }
    // this.partyCtrl = new FormControl("", [
    //   Validators.required,
    //   // hasValidParty.bind(this)
    // ]);

    //FOR AUTO COMPLETE VALIDATION --- MODEL COMBO
    // function hasValidModel(input: FormControl) {
    //   let brandID = input.value,
    //     retVal = null;
    //   if (brandID == "") {
    //     retVal = { inValidModel: true };
    //   }
    //   if (brandID && typeof brandID === "string") {
    //     retVal = { inValidModel: true };
    //   }
    //   return retVal;
    // }
    // this.modelCtrl = new FormControl("", [
    //   Validators.required,
    //   hasValidModel.bind(this),
    // ]);

    //FOR AUTO COMPLETE VALIDATION --- BRAND MODEL
    function hasValidType(input: FormControl) {
      let ledgerID = input.value,
        retVal = null;
      if (ledgerID != "HA Model" && ledgerID != "Spare") {
        retVal = { inValidType: true };
      }

      return retVal;
    }
    this.typeCtrl = new FormControl("", [
      Validators.required,
      hasValidType.bind(this),
    ]);

    this.serviceDet = [];
    // this.serviceDet['mode'] = 'Add';

    this.branchCtrl = new FormControl();
    this.filteredBranch = this.branchCtrl.valueChanges
      .startWith(null)
      .map((name) =>
        name ? this.filterBranch(name) : this.branchList.slice()
      );

    this.typeCtrl = new FormControl("", [
      Validators.required,
      hasValidType.bind(this),
    ]);
    this.numCtrl = new FormControl("", [Validators.required]);
    this.dateCtrl = new FormControl("", [Validators.required]);
  }

  filterBranch(name: string) {
    name = _.escapeRegExp(name);
    return this.branchList.filter((item) =>
      new RegExp(name, "gi").test(item.branch_name)
    );
  }
  displayFn(branchID: any) {
    if (this.branchList != undefined) {
      if (branchID && this.branchList.length > 0) {
        let fitem = _.find(this.branchList, { branch_id: branchID });
        return fitem["branch_name"];
      }
    }
    return "";
  }

  ngOnInit(): void {
    this.typeList = ["Client Walk in", "Testing", "Trail"];
    this.serviceDet["voucher_date"] = new Date();
  }

  onVoucherDateChange(): void {
    var toast = {
      type: "error",
      title: "ERROR",
    };

    if (this.serviceDet["upd_voucher_date"]) 
    {
      this.serviceDet["upd_voucher_date"] = moment(this.serviceDet["upd_voucher_date"])
      .format("YYYY-MM-DD");
    } else {
      this.serviceDet["upd_voucher_date"] = "";
    }

    let that = this,
      data = {
        service_type: this.serviceDet["service_type"],
        voucher_date: moment(this.serviceDet["voucher_date"]).format("YYYY-MM-DD"),
        client_no: this.serviceDet["client_no"],
        client_name: this.serviceDet["client_name"],
        upd_voucher_date: this.serviceDet["upd_voucher_date"],
      };

      if (data.service_type == undefined || data.service_type == "") {
        swal("WARNING", "Please Select Service Type");
        return;
      }
  
      if (data.client_no == undefined || data.client_no == "") {
        swal("WARNING", "Please Enter client No");
        return;
      }
  
      if (data.upd_voucher_date == undefined || data.upd_voucher_date =='') {
        swal("WARNING", "Please Enter Update Date");
        return;
      }

                that.isLoading = true;
                that.isLoadMask = that.commonService
                .updateClientWalkDate(data)
                    .then(function(res: any) {

                        that.isLoading = false;
                        if (res.success) {
                            that.serviceDet = [];
                            swal('SUCCESS', res.message, 'success');
                            that.serviceDet['voucher_date'] = new Date();
                            //  that.onReset();
                            // that.getStockList();
                        } else {
                            
                            var toast = {
                                type: 'error',
                                title: 'ERROR',
                                body: res.message
                            };
                            that.toasterService.pop(toast);
                        }
                    });
    

  }

  
}










































// swal({
//   title: "Are you sure to Delete?",
//   text:
//     "You will not be able to Recover Voucher No: " +
//     data.client_no +
//     " Again!",
//   showCancelButton: true,
//   confirmButtonText: "Yes, Delete!",
//   cancelButtonText: "No, Keep it",
// }).then(
//   function () {
//     that.isLoading = true;
//     that.isLoadMask = that.commonService
//       .deleteVoucherAmount(data)
//       .then(function (res: any) {

//         that.isLoading = false;
//         if (res.success) {
//           that.serviceDet = [];
//           swal("SUCCESS", res.message, "success");
//           //  that.onReset();
//           // that.getserviceList();
//         } else {
//           var toast = {
//             type: "error",
//             title: "ERROR",
//             body: res.message,
//           };
//           that.toasterService.pop(toast);
//         }
//       });
//   },
//   function (dismiss) {}
// );



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/dataCorrection/walkin_trail_testing/datechange.component.ts